/**
 * ARMITA Frontend - Centralized API Configuration
 *
 * This module provides a single source of truth for the backend API URL.
 * The URL is configured via environment variable for different deployments.
 */

// API URL from environment variable, with fallback for development
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default API_URL;
